import React from 'react'
import { get } from 'lodash'
import { setPlaySourcePrefix } from '~/tools/analytics/cleverTap'

class Carousel32_9Items extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.data && props.data.contentData
    }
    this.handleClick = this.handleClick.bind(this)
  }
  getCenteredBgImgStyle(imgUrl) {
    return { 
      background: `url(${imgUrl}?imwidth=1200)`,
      backgroundSize: "cover", 
      backgroundPosition: "center",
      backgroundRepeat: 'no-repeat' 
    }
  }

  handleClick(title){
    setPlaySourcePrefix('Carousel')
  }

  render() {
    var item = this.props.item
    var gist = item.gist
    const hideInfo = get(this.props.layoutSettings, 'noInfo')
    var url = `${(get(gist.imageGist, '_32x9') || get(window.settings, 'images.placeholderCover'))}`

    return (
      <a onClick={_ => this.handleClick(gist.title)} className="carousel-item" href={gist.permalink}>
        <div className="image" style={this.getCenteredBgImgStyle(url)} />
        <div className="play-icon site-color"><i className="ion-ios-play" /></div>
        {!hideInfo && <div className="foot">
          <div className="info">
            <span className="title">{gist.title}</span>
            <span className="more">
              {gist.runtime && Math.ceil(gist.runtime / 60) + 'mins | '}
              {gist.year && gist.year + ' |'}
              {gist.primaryCategory && gist.primaryCategory.title && gist.primaryCategory.title}
            </span>
          </div>
          <div onClick={_ => this.handleClick(gist.title)} className="cta" href={gist.permalink}>Watch Now</div>
        </div>}
      </a>
    )
  }
}

export default Carousel32_9Items
